
/**
 * @file
 * Provides base widget behaviours.
 */

(function ($, Drupal, once) {

  'use strict';

  Drupal.behaviors.externalResourceToggle = {
    attach: function (context) {
      once('external-resource-view', '.views-view-responsive-grid__item div.resource-wrapper', context).forEach((resourceWrapper) => {
        $(resourceWrapper).find('.resource-container-wrapper').on('click', toggleResourceAndPositionEntity)
        window.addEventListener('resize', positionEntityAndArrow)
      });
    }
  };

  // Toggle active on the resource wrapper, position the now showing entity.
  function toggleResourceAndPositionEntity() {
    const resourceWrapper = $(this).closest('div.resource-wrapper');
    // If an active container exists, we need to hide it.
    const activeResource = $(".views-view-responsive-grid__item div.resource-wrapper.active")
    if(activeResource && activeResource.attr('id') !== resourceWrapper.attr('id')) {
      hideResource(activeResource)
    }

    // Check the state of the clicked resource.
    if(resourceWrapper.hasClass('active')) {
      hideResource(resourceWrapper)
    } else {
      // Show resource.
      resourceWrapper.addClass('active')
      positionEntityAndArrow()
      hideClickOutsideEntity('.views-view-responsive-grid__item div.resource-wrapper.active')
    }
  }

  /**
   * Hide the selected resource and its rendered entity.
   */
  function hideResource(resourceWrapper) {
    const renderedEntity = resourceWrapper.find('.rendered-entity');
    const gridItem = resourceWrapper.closest('.views-view-responsive-grid__item');

    // Was active, disable it and fix padding.
    resourceWrapper.removeClass('active')
    gridItem.css('margin-bottom', "")
    renderedEntity.css('margin-left', "")
  }

  /**
   * Calculate position for the rendered entity.
   *
   * Calculate the margin bottom for the grid item, the margin left and before
   * left (Pseudo element variable) to position it correctly for the page.
   *
   * This doesn't use $(this) so the code can be used for both the resize and
   * on click event.
   */
  function positionEntityAndArrow() {
    const resourceWrapper = $('.resource-wrapper.active')

    if(resourceWrapper.length > 0) {
      const renderedEntity = resourceWrapper.find('.rendered-entity')
      const gridItem = resourceWrapper.closest('.views-view-responsive-grid__item')
      const firstGridChild = $('.views-view-responsive-grid--horizontal:first-child')

      let leftPos = gridItem.position().left - firstGridChild.position().left
      let offsetSize = gridItem.width() / 2 + leftPos - 75 / 2

      renderedEntity.css('--before-left', `${offsetSize}px`)
      renderedEntity.css('margin-left', renderedEntity.width() / -2)
      const adjustMargin = () => {
        const resourceWrapper = renderedEntity.closest('.resource-wrapper')
        if(resourceWrapper.hasClass('active')) {
          gridItem.css('margin-bottom', renderedEntity.height() + 64);
        }
      };

      new ResizeObserver(adjustMargin).observe(renderedEntity[0]);

    }
  }

  /**
   * Add event listener on active resources that will close and reset them
   * when clicked outside.
   */
  function hideClickOutsideEntity(selector) {
    const outsideClickListener = (event) => {
      const target = $(event.target);
      if (!target.closest(selector).length && $(selector).is(':visible')) {
        hideResource($(selector));
        removeClickListener();
      }
    }

    const removeClickListener = () => {
      $(document).off('click', outsideClickListener);
    }

    $(document).on('click', outsideClickListener);
  }


})(jQuery, Drupal, once);
